/* dalsiUdajeSave — čistá logika blur-save v záložce „Další údaje" (WS Fáze 4 QA fix).
 *
 * PROČ EXISTUJE: SaveBlock v DalsiUdajeTab poslouchá globální `blur` (capture) a
 * musí z rozostřeného <input> zjistit, KTERÉ pole formuláře se má uložit. Dřív to
 * dělal inline přes `id?.includes(field.replace(/_/g,"-"))`:
 *   1) pole BEZ `data-testid` (spis_znacka, group/Skupina) → `id` bylo null → žádná
 *      shoda → editace se TIŠE NEULOŽILA (poradce přišel o zapsanou hodnotu),
 *   2) `includes` mohl teoreticky křížově chytit pole, jehož dashed klíč je
 *      podřetězcem jiného testidu.
 * Řešení: přesná shoda na konci testidu (`dalsi-<klíč>`) + čitelná změnová detekce,
 * obojí pokryté unit testy. Fix v komponentě: doplnit chybějící testidy.
 */

/* Z data-testid rozostřeného inputu vrátí klíč pole formuláře, nebo null.
 * Testid má tvar „dalsi-<klíč-s-pomlčkami>"; klíče formuláře jsou s podtržítky.
 * Přesná shoda (=== nebo koncovka „-<klíč>") místo volného includes → žádné
 * křížové chyby a jasné selhání, když testid chybí (=null → volající neuloží). */
export function resolveSaveFieldKey(testid, fields) {
  if (!testid || !Array.isArray(fields)) return null;
  return (
    fields.find((f) => {
      const dashed = String(f).replace(/_/g, "-");
      return testid === dashed || testid.endsWith(`-${dashed}`);
    }) || null
  );
}

/* True, když se hodnota pole ve formuláři liší od uloženého kontaktu.
 * Prázdno (null/undefined/"") se považuje za shodné, aby se neposílal zbytečný
 * patch „" → null. */
export function fieldChanged(form, contact, key) {
  const cur = form?.[key] ?? "";
  const orig = contact?.[key] ?? "";
  return cur !== orig;
}
